module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-248.6b1fe790.svg";